// extracted by mini-css-extract-plugin
export default {"activeColor":"TypeSeries_activeColor__ce9fY","textEllipsis":"TypeSeries_textEllipsis__Lv+dY"};